/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorAppLabInfo } from '../../models/editor-app-lab-info';

export interface AppControllerFindEditorAppLabList$Params {
  language: string;
}

export function appControllerFindEditorAppLabList(http: HttpClient, rootUrl: string, params: AppControllerFindEditorAppLabList$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<EditorAppLabInfo>>> {
  const rb = new RequestBuilder(rootUrl, appControllerFindEditorAppLabList.PATH, 'get');
  if (params) {
    rb.path('language', params.language, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<EditorAppLabInfo>>;
    })
  );
}

appControllerFindEditorAppLabList.PATH = '/app/dummy-method';
